export default __webpack_public_path__ + "static/card-1-70ed23956b97877047985894764edf76.svg";